import { CodelistContract } from './contracts/CodelistContract.js';

function stableStringify(value) {

    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return `[${value.map((item) => stableStringify(item)).join(',')}]`;
    if (typeof value !== 'object') return JSON.stringify(value);

    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;

}

export class CodelistService extends CodelistContract {

    constructor(options = {}) {

        super();

        const {
            httpClient,
            resourcePath = null,
            codelistPath = null,
            storage = null,
            cacheSlotName = null,
            persistent = false,
            expiresIn = 300,
            cacheKeyFactory = null,
        } = options;

        if (!httpClient) throw new Error('CodelistService: "httpClient" is required.');
        if (!resourcePath && !codelistPath) {
            throw new Error('CodelistService: either "resourcePath" or "codelistPath" is required.');
        }

        this.http = httpClient;
        this.resourcePath = resourcePath ? String(resourcePath).replace(/\/+$/, '') : null;
        this.codelistPath = codelistPath ? String(codelistPath).replace(/\/+$/, '') : null;
        this.storage = storage;
        this.cacheSlotName = cacheSlotName;
        this.persistent = persistent === true;
        this.expiresIn = expiresIn;
        this.cacheKeyFactory = cacheKeyFactory;

    }

    async queryCodelistData(query = null, options = {}) {

        if (!this.storage) {
            return this._fetchCodelistData(query);
        }

        const slotName = this.getCacheSlotName(query);
        return this.storage.loadOrCreateData(slotName, () => this._fetchCodelistData(query), {
            forceReload: options.forceReload === true,
            persistent: this.persistent,
            expiresIn: this.expiresIn,
        });

    }

    getCodelistPath() {
        return this.codelistPath || `${this.resourcePath}/codelist`;
    }

    getCacheSlotName(query = null) {

        const path = this.getCodelistPath();
        if (typeof this.cacheKeyFactory === 'function') {
            return this.cacheKeyFactory({ path, query, service: this });
        }

        const base = this.cacheSlotName || `codelist:${path}`;
        const queryKey = stableStringify(query);
        return queryKey ? `${base}:${queryKey}` : base;

    }

    async _fetchCodelistData(query = null) {
        const response = await this.http.get(this.getCodelistPath(), query, {
            responseType: 'json',
        });

        if (Array.isArray(response.payload))
            return response.payload;

        if (Array.isArray(response.payload?.items))
            return response.payload.items;

        return [];
    }

}
